// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610210659/js/" + chunkId + "." + {"44":"72155c3e","225":"e7ad6f1b","481":"42272fd7","486":"b2e2b831","770":"dba7ffa8"}[chunkId] + ".0.7850943629094906.chunk.js";
};